import { Injectable, computed, signal } from '@angular/core';

export interface SupportContact {
  email: string;
  phone: string;
}

const DEFAULTS: SupportContact = {
  email: 'support@npr.ng',
  phone: '09137146567',
};

/**
 * Public support phone and email, served from app-config so every surface
 * shows the same values an admin last saved.
 */
@Injectable({ providedIn: 'root' })
export class PlatformContactService {
  readonly email = signal(DEFAULTS.email);
  readonly phone = signal(DEFAULTS.phone);

  readonly emailHref = computed(() => `mailto:${this.email()}`);
  readonly phoneHref = computed(() => `tel:${this.phone().replace(/[^\d+]/g, '')}`);

  apply(contact?: Partial<SupportContact> | null): void {
    const email = contact?.email?.trim();
    const phone = contact?.phone?.trim();
    if (email) {
      this.email.set(email);
    }
    if (phone) {
      this.phone.set(phone);
    }
  }
}
